import angular from 'angular';
import { NumericDirectiveModule } from '../numeric/numeric.directive';

export const SumDirectiveModule = angular.module('acme.common.directive.sum', [
  NumericDirectiveModule
])
.directive('sum', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/sum/sum.tpl.html',
      scope: {
        min: '@',
        max: '@',
        cost: '@',
        total: '=',
        quantity: '=',
        remaining: '=',
        groupQuantity: '=',
        labelledby: '@',
        groups: '=?',
        groupMember: '=',
        groupMemberCheck: '@',
        disableActions: '@',
        limit: '@'
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$timeout', function($scope, $timeout) {

        $scope.sum = {

          total: 0,
          min: 0,
          max: 0,
          quantityWatcher: {},
          groupsWatcher: {},
          disableAdd: false,
          disableSubtract: false,
          isMaxed: false,
          isDirty: false,
          labelledby: '',
          groups: [],
          groupMemberCheck: true,
          disableActions: true,

          init: function() {
            this.quantityWatcher = $scope.$watch('quantity', this.onQuantityUpdate);
            this.groupsWatcher = $scope.$watch('groups', this.onGroupsUpdate);
            this.labelledby = $scope.labelledby;

            if (!$scope.quantity && $scope.min) {
              $scope.quantity = +$scope.min;
            }

            if ($scope.groupMemberCheck) {
              this.groupMemberCheck = ($scope.groupMemberCheck === "false") ? false : true;
            }

            if ($scope.disableActions) {
              this.disableActions = ($scope.disableActions === "false") ? false : true;
            }

            $scope.$on('$destroy', $scope.$watch('max', this.onMaxUpdate));
            $scope.$on('$destroy', $scope.$watch('remaining', this.onRemainingUpdate));
            $scope.$on('Event::selectHour', this.onEventSelectHour);
            $scope.$on('Event::selectComboHour', this.onEventSelectHour);
            $scope.$on('Event::updatedLimits', this.onEventUpdatedLimits);
          },

          add: function() {
            this.isDirty = true;
            this.checkRemaining();

            if (this.disableAdd === false) {
              if ($scope.max) {
                if (!this.disableActions) {
                  $scope.quantity = +$scope.quantity + 1;
                } else {
                  $scope.quantity = (+$scope.quantity + 1 <= $scope.max) ? +$scope.quantity + 1 : +$scope.max;
                }
              } else {
                $scope.quantity = +$scope.quantity + 1;
              }
            }

          },

          subtract: function() {
            this.isDirty = true;
            this.checkRemaining();

            if (this.disableSubtract === false) {
              if ($scope.min) {
                $scope.quantity = (+$scope.quantity - 1 >= $scope.min) ? +$scope.quantity - 1 : +$scope.min;
              } else {
                $scope.quantity = (+$scope.quantity - 1 >= 0) ? +$scope.quantity - 1 : 0;
              }
            }

          },

          checkRemaining: function() {
            var i, ii;

            console.log('Sum::checkRemaining', $scope.remaining);

            //First check capacity for the event
            if ($scope.remaining < 0) {
              this.isMaxed = true;
            }

            // check Sales rules
            // check Member rules - across tyckettypes rule (highlight only discount tickets / regular with no discount)
            else if ($scope.groups instanceof Array && $scope.groups.length) {
              // groupMax - groupQuantity is the max
              this.isMaxed = false;
              this.disableAdd = false;

              for (i=0, ii=$scope.groups.length; i < ii; i++) {

                if (
                  $scope.groups[i].ruleType.name === 'eventSales' ||
                  ($scope.groups[i].ruleType.name === 'memberBenefits' && this.groupMemberCheck )
                ) {

                  if (!this.isMaxed && ($scope.groups[i].groupQuantity > $scope.groups[i].groupMax)) {
                    this.isMaxed = ($scope.groups[i].groupQuantity > $scope.groups[i].groupMax);

                    if ($scope.groups[i].isPreventRule && this.isMaxed) {
                      this.isMaxed = ($scope.groups[i].preventGroupQuantity > 0);
                    }
                  }

                  if ($scope.groups[i].isPreventRule && !$scope.groups[i].inCartLimit) {
                    this.isMaxed = ($scope.groups[i].preventGroupQuantity > 0);
                  }

                  if (!this.disableAdd && ($scope.groups[i].groupQuantity >= $scope.groups[i].groupMax)) {
                    this.disableAdd = ($scope.groups[i].groupQuantity >= $scope.groups[i].groupMax);
                  }

                }
              }
            }

            // check Sales rules for limit single with retail tickets
            // check Member rules - each ticketTypes rule (highlight only check discount tickets)
            else if ($scope.groupMember && $scope.groupMember.ruleType && $scope.max) {
              if ($scope.groupMember.ruleType.name === "eventSales") {
                this.isMaxed = ($scope.groupQuantity > parseInt($scope.max, 10));
              } else if($scope.groupMember.ruleType.name === "memberBenefits" && this.groupMemberCheck) {
                this.isMaxed = ($scope.quantity > parseInt($scope.max, 10));
              }
            }

            else if ($scope.groupQuantity && $scope.max) {
              this.isMaxed = ($scope.groupQuantity > parseInt($scope.max, 10));
            }

            //then check max
            else if ($scope.max) {
              this.isMaxed = ($scope.quantity > Math.abs($scope.max));
              this.disableAdd = ($scope.quantity >= Math.abs($scope.max));
            } else{
              this.disableAdd = false;
              this.isMaxed = false;
            }

            if (!this.disableActions) {
              this.disableAdd = false;
            }
          },

          checkGroupMax: function() {
            console.log('Sum::checkRemaining', $scope.remaining);

            if ($scope.remaining < 1) {
              this.disableAdd = true;
              this.isMaxed = true;

              // Remove negative remaining seats from quantity if it is exceeded
              if ($scope.quantity > Math.abs($scope.remaining)) {
                $scope.quantity -= Math.abs($scope.remaining);
                $scope.remaining = 1;
              }else{
                this.isMaxed = false;
                $scope.quantity = 0;
                $scope.remaining = 0;
              }
            } else if ($scope.max) {
              this.isMaxed = ($scope.quantity > Math.abs($scope.max));
              this.disableAdd = ($scope.quantity >= Math.abs($scope.max));
            } else{
              this.disableAdd = false;
              this.isMaxed = false;
            }
          },

          updateTotal: function() {
            $scope.total = this.getTotal();

            $timeout(function() {
              $scope.$emit('Sum::UpdateTotal');
            }, 10);
          },

          getTotal: function() {
            const cost = +$scope.cost * 100;
            return ($scope.quantity * parseInt(String(cost), 10) / 100);
          },

          onDestroy: function() {
            $scope.sum.quantityWatcher();
            $scope.sum.groupsWatcher();
          },

          onEventSelectHour: function() {
            $scope.sum.onQuantityUpdate();

            if ($scope.quantity >= Math.abs($scope.remaining)) {
              $scope.quantity = Math.abs($scope.remaining);
              $scope.remaining = 0;
            }
          },

          onEventUpdatedLimits: function() {
            $scope.sum.checkRemaining();
          },

          onQuantityUpdate: function() {
            console.log('Sum::onQuantityUpdate');
            $scope.sum.updateTotal();
            if ($scope.sum.isDirty) {
              $timeout(function() {
                $scope.sum.checkRemaining();
              }, 20);
            }
          },

          onGroupsUpdate: function(newValue, oldValue) {
            console.log('Sum::onGroupsUpdate');
            if (oldValue && (newValue !== oldValue)) {
              $scope.sum.checkRemaining();
            }
          },

          onMaxUpdate: function() {
            $scope.sum.isDirty = true;
            $scope.sum.checkRemaining();
          },

          onRemainingUpdate: function() {
            $scope.sum.isDirty = true;
            $scope.sum.checkRemaining();
          }

        };

        $scope.sum.init();

      }]

    };

}]).name;
